import dayjs from "dayjs"

// Stands in for a question UUID when a date difference question's start date
// or end date is the date the form was filled out rather than the answer to
// another question on the form.
//
// Only public forms and survey forms may use the current date, and only for
// one of the two dates.
export const CURRENT_DATE = "currentDate"

export const DAYS = "days"
export const WEEKS = "weeks"
export const MONTHS = "months"
export const YEARS = "years"

export const UNITS_OF_MEASURE = [DAYS, WEEKS, MONTHS, YEARS]

// Whole units elapsed between two YYYY-MM-DD dates, truncated toward zero.
//
// Weeks are days divided by seven.  Months and years are anchored on the day
// of the month, the way an age is calculated: January 15 to March 20 is two
// months, and April 1, 2026 to April 1, 2027 is one year.  When the start
// date's day of the month does not exist in the end date's month, the end of
// that month counts as the anniversary, so January 31 to February 28 is one
// month.
//
// The result is negative when the end date precedes the start date, which is
// meaningful for a question comparing a date to an expiration date.
//
// An unrecognized unit yields nothing rather than a difference, because dayjs
// falls back to milliseconds and would otherwise report a plausible looking
// number that measures something else entirely.
export const getDateDifference = (startDate, endDate, unitOfMeasure) => {
  if (!UNITS_OF_MEASURE.includes(unitOfMeasure)) return null

  return dayjs(endDate).diff(startDate, unitOfMeasure)
}
